module.exports = __webpack_public_path__ + "img/106.4d54dae7.png";